import { CompanyFilterContextProvider } from "../../superAdmin/components/context/CompanyFilterContext";
import CompanyAnalyticsDashboard from "../../superAdmin/superdashboard/CompanyAnalyticsDashboard";

const DASHBOARD_FILTER_CONFIG = {
    tiers: false,
    status: false,
    executive: false,
    companies: false,
    dateRange: true,
};

const AnalyticsDashboardPage = () => {
    return (
        <CompanyFilterContextProvider filterConfig={DASHBOARD_FILTER_CONFIG}>
                <CompanyAnalyticsDashboard />
        </CompanyFilterContextProvider>
    );
};

export default AnalyticsDashboardPage;
